import { createStyles, makeStyles } from '@material-ui/styles'
import colors from 'shared/style/colors'

export const useStyles = makeStyles(() =>
  createStyles({
    link: {
      color: 'inherit',
      textDecoration: 'none',
      '&:visited': {
        color: 'inherit'
      },
      '& .highlightable': {
        boxShadow: `0.08rem 0.08rem 0.2rem ${colors.highlightable}`,
        '&:hover': {
          boxShadow: `0.15rem 0.15rem 0.25rem ${colors.hoverHighlightable}`
        }
      }
    },
    linkText: {
      display: 'inline-block',
      color: colors.primary,
      marginBottom: '.5rem'
    },
    linkFooter: {
      marginBottom: '.5rem',
      display: 'inline-block',
      color: 'inherit',
      textDecoration: 'none',
      '&:visited': {
        color: 'inherit'
      },
      '& .highlightable': {
        boxShadow: `0.08rem 0.08rem 0.2rem ${colors.highlightable}`,
        '&:hover': {
          boxShadow: `0.15rem 0.15rem 0.25rem ${colors.hoverHighlightable}`
        }
      }
    }
  })
)
